// eslint-disable-next-line no-unused-vars
import Vue from 'vue'

const instanceList = {}

/*
 * 初始化实例
 */
const _initInstance = function (key, viewConstructor) {
  if (instanceList[key] && instanceList[key]._INSTANTIATION_) {
    return instanceList[key]
  }
  // eslint-disable-next-line new-cap
  instanceList[key] = new viewConstructor({
    el: document.createElement('div')
  })
  instanceList[key]._INSTANTIATION_ = true
  return instanceList[key]
}

/*
 * 初始化数据
 */
const _initData = function (instance, options) {
  const op = Object.assign({}, options)
  for (const prop in op) {
    // eslint-disable-next-line no-prototype-builtins
    if (op.hasOwnProperty(prop)) {
      instance[prop] = op[prop]
    }
  }
}

/*
 * 声明
 */
const Portal = function (key, viewConstructor) {
  this.viewConstructor = viewConstructor
  this.key = key
}

// init
Portal.prototype.init = function (options) {
  const _instance = _initInstance(this.key, this.viewConstructor)
  _initData(_instance, options)
  if (!_instance._MOUNTED_) {
    document.body.appendChild(_instance.$el)
    _instance._MOUNTED_ = true
    // 延迟打开以正确展示过渡效果
    setTimeout(() => {
      _instance.open()
    }, 0)
  } else {
    _instance.open()
  }
}

// close 方法
Portal.prototype.closeInstance = function () {
  if (instanceList[this.key] && instanceList[this.key]._INSTANTIATION_) {
    instanceList[this.key].close()
  }
}

// clear 方法
Portal.prototype.clear = function () {}

// eslint-disable-next-line import/no-default-export
export default Portal
